'use strict';

var React = require('react'),
    SafeLocalStorage = require('../utils/SafeLocalStorage'),
    { PropTypes } = React;

/**
 * TODO: use a dedicated Store instead when we rewrite to use new forms.
 */
var PendingStampMessageMixin = {
  propTypes: {
    stampId: PropTypes.number.isRequired,
    zineSlug: PropTypes.string.isRequired
  },

  getStorageKey() {
    return 'PendingStampMessageMixin.review-' + this.props.stampId + '-' + this.props.zineSlug;
  },

  getInitialState() {
    var message = SafeLocalStorage.getItem(this.getStorageKey());

    return {
      message: message || ''
    };
  },

  componentDidUpdate: function (prevProps, prevState) {
    if (this.state.message === prevState.message) {
      return;
    }

    SafeLocalStorage.setItem(this.getStorageKey(), this.state.message);
  },

  removeStoredPendingMessage() {
    SafeLocalStorage.removeItem(this.getStorageKey());
  }
};

module.exports = PendingStampMessageMixin;


/** WEBPACK FOOTER **
 ** ./mixins/PendingStampMessageMixin.js
 **/